import React, { useEffect, useState } from 'react'; 
import { fetchLatestBlocksSummary } from '../services/apiService';
import { FaCube, FaFingerprint, FaUsers, FaMoneyBillAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const LatestTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const transactionsPerPage = 10;

  useEffect(() => {
    fetchLatestBlocksSummary().then(data => {
      setTransactions(data);
    });
  }, []);

  const getTimeElapsed = (txTimestamp) => {
    if (!txTimestamp) return '';
    const now = new Date();
    const txTime = new Date(txTimestamp);
    const diffInSeconds = Math.floor((now - txTime) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} seg`;
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} min`;
    } else {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} h`;
    }
  };

  // Calcular transacciones paginadas
  const indexOfLastTransaction = currentPage * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  const currentTransactions = transactions.slice(indexOfFirstTransaction, indexOfLastTransaction);
  const totalPages = Math.ceil(transactions.length / transactionsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const formatTxHash = (hash) => {
    const start = hash.substring(0, 8);
    const end = hash.substring(hash.length - 8);
    return `${start}...${end}`;
  };

  const formatAmount = (amount) => {
    return parseFloat(amount).toFixed(4);
  };

  // fondo según el valor de Amount
  const getRowStyle = (amount) => {
    if (amount > 200000) return 'bg-red-300';
    if (amount > 50000) return 'bg-yellow-300';
    return '';
  };

  return (
    <div className="bg-white shadow-md rounded p-4">
      <table className="table-auto w-full text-left">
        <thead>
          <tr>
            <th><FaCube /> Block</th>
            <th><FaFingerprint /> Tx</th>
            <th><FaUsers /> Recipients</th>
            <th><FaMoneyBillAlt /> Amount</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {currentTransactions.map(tx => (
            <tr key={tx.Tx_Hash} className={`border-b ${getRowStyle(tx.Amount)}`}>
              <td>{tx.Block}</td>
              <td className="truncate">
                <Link to={`/txid/${tx.Tx_Hash}`} className="text-blue-500 hover:underline">
                  {formatTxHash(tx.Tx_Hash)}
                </Link>
              </td>
              <td>{tx.Recipients}</td>
              <td>{formatAmount(tx.Amount)}</td>
              <td>{getTimeElapsed(tx.Timestamp)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Paginación */}
      <div className="flex justify-between items-center mt-4">
        <button
          className={`px-4 py-2 text-sm rounded ${currentPage === 1 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={`px-4 py-2 text-sm rounded ${currentPage === totalPages ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default LatestTransactions;
